import { Component } from '@angular/core';
import * as vars from "../../../app.global";
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'app/modules/core/services/auth/auth.service';
import { StatusService } from 'app/modules/core/services/user/status.service';
import { UIService } from 'app/modules/core/services/ui/ui.service';
import { Message } from 'app/modules/core/models/message';
import { User } from 'app/modules/core/models/user';
import { SharedService } from 'app/modules/shared/services';


@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    standalone: false
})
export class LoginComponent {
  version: string = vars.version;
  user: User = new User();
  patternemail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [
      Validators.required,
      Validators.email
    ]),
    password: new UntypedFormControl('', [Validators.required])
  });
  loading: boolean = false;
  showForgotPassword: boolean = false;
  forgotEmail: string = '';
  forgotLoading: boolean = false;
  loginErrorMessage: string = '';
  showPassword: boolean = false;

  constructor(private _router: Router,
    private _uiService: UIService,
    private _authService: AuthService,
    public _statusService: StatusService,
    public sharedService: SharedService
    ) { }

  login() {
    if (this.loading) return;
    this.loginErrorMessage = '';
    this.loginForm.setErrors(null);
    this.loginForm.controls['password'].setErrors(null);
    this.loginForm.markAllAsTouched();
    this.loginForm.markAsDirty();
    this.loginForm.controls['email'].updateValueAndValidity();
    this.loginForm.controls['password'].updateValueAndValidity();
    this.user.email = this.loginForm.controls['email'].value;
    this.user.password = this.loginForm.controls['password'].value;
    sessionStorage.setItem('userEmail', this.user.email);

    if (this.loginForm.controls['email'].value.length > 0) {
      // tslint:disable-next-line: max-line-length
      const emailregex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


      if (!emailregex.test(this.loginForm.controls['email'].value)) {
        this.loginForm.controls['email'].setErrors({
          'incorrect': true
        });
      }
    }


    if (this.loginForm.invalid) {
      let msg = new Message();
      if (
        this.loginForm.controls["email"].hasError("required") &&
        this.loginForm.controls["password"].hasError("required")
      ) {
        msg.msg = "Email and password are required.";
      } else if (this.loginForm.controls["email"].hasError("required")) {
        msg.msg = "Email is required.";
      } else if (this.loginForm.controls["email"].hasError("incorrect")) {
        msg.msg = "Invalid email address.";
      } else if (
        this.loginForm.controls["password"].hasError("required")
      ) {
        msg.msg = "Password is required.";
      }
      this._uiService.showToast(msg);
      // this.loading = false;
      return;
    }
    this.loading = true;
    this.user.email = this.user.email.toLocaleLowerCase();
    this._authService.checkLogin(this.user).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this._router.navigate(["/main/dashboard"]);
          this._authService.loginStatusChanged.next(true);
          // this.loading = false;
        }
      },
      error => {
        this.loading = false;
        let errorMessage = 'Error occurred while logging in';
        // Show server-provided message if available, otherwise a friendly fallback
        if (error && error.error) {
          // If backend returns a string message
          if (typeof error.error === 'string') {
            errorMessage = error.error;
          } else if (error.error.message) {
            errorMessage = error.error.message;
          } else {
            errorMessage = 'Login failed. Please check your credentials and try again.';
          }
        } else if (error && error.status === 401) {
          errorMessage = 'Invalid email or password';
        } else {
          errorMessage = 'Error occurred while logging in';
        }

        this.loginErrorMessage = errorMessage;
        this.loginForm.setErrors({ invalidCredentials: true });
        this.loginForm.controls['password'].setErrors({
          ...(this.loginForm.controls['password'].errors || {}),
          invalidCredentials: true
        });
        this._uiService.showErrorToast(errorMessage);
      }
    );
  }

  toggleForgotPassword() {
    this.showForgotPassword = !this.showForgotPassword;
    this.forgotEmail = '';
  }

  submitForgotPassword() {
    const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.forgotEmail || !emailRegex.test(this.forgotEmail)) {
      let msg = new Message();
      msg.msg = 'Please enter a valid email address.';
      this._uiService.showToast(msg);
      return;
    }
    this.forgotLoading = true;
    this._authService.forgotPassword(this.forgotEmail).subscribe({
      next: () => {
        this.forgotLoading = false;
        this.showForgotPassword = false;
        this.forgotEmail = '';
        this._uiService.showSuccessToast('A new password has been sent to your email.');
      },
      error: (error) => {
        this.forgotLoading = false;
        if (error?.error && typeof error.error === 'string') {
          this._uiService.showErrorToast(error.error);
        } else if (error?.error?.message) {
          this._uiService.showErrorToast(error.error.message);
        } else {
          this._uiService.showErrorToast('Failed to reset password. Please check your email and try again.');
        }
      }
    });
  }

  navigateToDraftReport() {
    this._router.navigate(
      ['/main/my-reports/draft'],
      { queryParams: { draftMode: 'offline' } }
    );
  }
}

